<modal>
  <span header class="uppercase text-warning">{{'Thêm/Bớt công nợ cho' | lang}} {{partner.Name}}</span>
  <p>{{'Ngày'}}</p>
  <calendar [selected]="time" (change)="time=$event"></calendar>
  <p>{{'Số tiền' | lang}} (đ)</p>
  <number-input class="text-center" [ngClass]="{'text-success': debt.Total < 0, 'text-danger': debt.Total > 0}" [value]="-debt.Total" (change)="update($event.target)" [allowNegativeValue]="true"></number-input>
  <p>{{'Lý do' | lang}}</p>
  <textarea [(ngModel)]="debt.Reason"></textarea>

  <div class="flex">
    <button class="text-white bg-success" (click)="save()"><i class="fa fa-save"></i><span>{{'Lưu' | lang}}</span></button>
    <button class="text-white bg-warning" (click)="close()"><i class="fa fa-arrow-left"></i><span>{{'Quay lại' | lang}}</span></button>
  </div>
</modal>
